import { createAction, Dispatch } from '@reduxjs/toolkit';
import { SearchTerm } from '@customTypes/shared/SearchTerm';

export const updateSearchTerm = createAction<SearchTerm>('updateSearchTerm');

export const setSavedSearchTerm = (type: string, searchTerm: string) => (dispatch: Dispatch) => {
    return dispatch(updateSearchTerm({ type, searchTerm }));
};
